import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { bool, string, func, arrayOf, shape } from 'prop-types';

import Icon from 'components/icon';
import { getInitialExpandedAccordionFilterIndex } from '../../../utils';

const AccordionFilters = ({
    handleRadioChange,
    isLoading,
    filters,
    labelCollapse,
    labelExpand,
    renderFilter
}) => {
    const [activeIndex, setActiveIndex] = useState(
        getInitialExpandedAccordionFilterIndex(filters)
    );

    const handleOnSelect = id => {
        setActiveIndex(id);
    };

    if (!filters || !filters.length) {
        return null;
    }

    return (
        <React.Fragment>
            {filters.map((item, index) => {
                const { id, label, radio } = item;
                const isExpanded = index === activeIndex;
                const labelId = `label-${item.id}`;
                const contentId = `content-${item.id}`;
                const accessibilityTitle = isExpanded
                    ? labelCollapse
                    : labelExpand;
                const iconName = isExpanded
                    ? 'arrow-drop-up'
                    : 'arrow-drop-down';

                return (
                    <div className="collapsible-filters" key={id}>
                        <h3 className="collapsible-filters__trigger radiobutton-wrapper">
                            <input
                                id={radio.id.toString()}
                                name="categories"
                                onChange={() => handleRadioChange(id)}
                                checked={radio.checked}
                                disabled={isLoading}
                                type="radio"
                                value={radio.value}
                            />
                            <label
                                aria-controls={contentId}
                                aria-expanded={isExpanded}
                                className="collapsible-filters__trigger-button"
                                id={labelId}
                                onClick={() =>
                                    handleOnSelect(isExpanded ? null : index)
                                }
                                title={accessibilityTitle}
                                htmlFor={radio.id.toString()}
                            >
                                <span className="collapsible-filters__trigger-text">
                                    {label}
                                </span>
                                <Icon glyph={iconName} />
                                <span className="u-sr-only">
                                    {accessibilityTitle}
                                </span>
                            </label>
                        </h3>
                        <AnimateHeight
                            aria-labelledby={labelId}
                            duration={400}
                            height={isExpanded ? 'auto' : 0}
                            id={contentId}
                        >
                            <div className="collapsible-filters__content">
                                {renderFilter(item)}
                            </div>
                        </AnimateHeight>
                    </div>
                );
            })}
        </React.Fragment>
    );
};

AccordionFilters.propTypes = {
    filters: arrayOf(
        shape({
            id: string,
            type: string,
            label: string,
            options: arrayOf(
                shape({
                    id: string,
                    label: string,
                    value: string,
                    checked: bool,
                    disabled: bool
                })
            ),
            radio: shape({
                id: string,
                value: string,
                checked: bool
            }),
            advancedFiltersId: string
        })
    ).isRequired,
    handleRadioChange: func.isRequired,
    renderFilter: func,
    isLoading: bool,
    labelCollapse: string.isRequired,
    labelExpand: string.isRequired
};

export default AccordionFilters;
